import React, { forwardRef } from 'react';
import { BrainIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { IMAGES } from '../data/links';
export const Hero = forwardRef<HTMLAnchorElement>(function Hero(_props, ctaRef) {
  return <header className="bg-cream px-4 pb-14 pt-6 sm:pb-20 sm:pt-10" data-id="element-158" data-mp="4lqkazhutj53">
      <div className="mx-auto max-w-5xl text-center" data-id="element-159" data-mp="4njp098wptag">
        <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-160" data-mp="129qv5nkuztox">
          <span className="grid h-10 w-10 place-items-center rounded-xl bg-brand text-white" data-id="element-161" data-mp="xae5yw6imaj6">
            <BrainIcon className="h-5 w-5" aria-hidden="true" data-id="element-162" data-mp="sbb0xbqjc4b7" />
          </span>
          <span className="font-serif text-lg font-bold text-ink" data-id="element-163" data-mp="sde0onhhpbt4">
            Clinical Pathway<sup className="text-[10px]" data-id="element-164" data-mp="nbygsyr1tbcb">™</sup>
          </span>
        </div>

        <p className="mx-auto mt-5 inline-block rounded-full border border-brand/20 bg-white px-4 py-1.5 text-[11px] font-bold uppercase tracking-wider text-brand sm:text-xs" data-id="element-165" data-mp="3d2ldtocrhr6i">
          The Sensory Modulation Clinical Reasoning System
        </p>

        <h1 className="mx-auto mt-5 max-w-4xl text-balance font-serif text-[36px] font-extrabold leading-[1.06] text-ink sm:text-5xl lg:text-[64px]" data-id="element-166" data-mp="3j6o8rb5sq6lv">
          Organize a Sensory Modulation Case in <em className="text-brand" data-id="element-167" data-mp="39cfofaqx5jys">15 Minutes</em>
        </h1>
        <p className="mt-3 font-serif text-[21px] font-bold italic text-ink/80 sm:text-2xl" data-id="element-168" data-mp="3e84nze2xv0v3">— Without Getting Lost in Theory</p>

        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-muted sm:text-lg" data-id="element-169" data-mp="30fy7trzsctvn">
          A step-by-step educational reasoning system designed to help <strong className="text-ink" data-id="element-170" data-mp="2qkwkn1p2m1vp">Pediatric Occupational Therapists</strong>{' '}
          organize behavioral observations, explore possible sensory modulation patterns, identify missing information, and develop clearer
          working hypotheses.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-[16px] leading-relaxed text-ink sm:text-[17px]" data-id="element-171" data-mp="2lkimcbd9u6av">
          Includes <strong data-id="element-172" data-mp="s2jmbumnjwig">6 Premium Volumes</strong>, <strong data-id="element-173" data-mp="s2tdvmncibq9">5 Professional Bonuses</strong>, and{' '}
          <strong data-id="element-174" data-mp="nbl3anaa4kbi">30+ Practical Decision Tools</strong>.
        </p>

        <img src={IMAGES.mockup} alt="The Sensory Modulation Clinical Pathway: six volumes, five bonuses and the decision toolkit" className="-mx-4 mt-6 block w-[calc(100%+2rem)] max-w-none sm:mx-auto sm:w-full sm:max-w-2xl" data-id="element-175" data-mp="n98djnya55nw" />

        <p className="mx-auto mt-2 max-w-xl font-serif text-lg italic leading-snug text-ink sm:text-xl" data-id="element-176" data-mp="1azkutpff0er5">
          A structured visual pathway to help you connect what you observe with what you still need to understand.
        </p>

        <CTAButton ref={ctaRef} className="mt-7" label="Get the Sensory Modulation Clinical Pathway™" sublabel="Instant digital access · One-time payment of USD $27 · Lifetime access · 7-Day Guarantee" data-id="element-177" data-mp="114svag29vhtq" />

        <div className="mt-8" data-id="element-178" data-mp="3hqaj2p91pbl1">
          <Countdown data-id="element-179" data-mp="3hq26kygu48ad" />
        </div>
      </div>
    </header>;
});